import { Box, Container, Typography } from "@mui/material";

export default function AboutPage() {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 4,
          gap: 4,
        }}>
        <img
          src="/icons/512.png"
          alt="ConventionPOS"
          style={{ width: 200, height: "auto", margin: "20px 0" }}
        />

        <Typography variant="body1">
          ConventionPOS was born from a simple need: tracking sales at
          conventions without the complexity and expense of traditional POS
          systems.
        </Typography>

        <Typography variant="body1">
          While a spreadsheet might do the job, I wanted something more tailored
          to the convention experience: a tool that could handle multiple items
          per sale, apply discounts easily, and most importantly, be
          straightforward to use in a fast-paced environment.
        </Typography>

        <Typography variant="body1">
          The built-in reporting features make it easy to analyse sales data,
          and you can export everything to CSV format for further analysis in
          your preferred spreadsheet software.
        </Typography>

        <Typography variant="body1">Key features:</Typography>

        <Box component="ul" sx={{ mt: -2 }}>
          <Typography component="li">Simple, focused sales logging</Typography>
          <Typography component="li">Works completely offline</Typography>
          <Typography component="li">Automated bundle calculation</Typography>
          <Typography component="li">Easy data import/export</Typography>
          <Typography component="li">
            No payment processing—just tracking
          </Typography>
          <Typography component="li">
            Multiple items and discount support
          </Typography>
          <Typography component="li">
            Built-in sales reports and analytics
          </Typography>
          <Typography component="li">Export reports to CSV format</Typography>
        </Box>

        <Typography variant="body1" sx={{ mt: 2 }}>
          Built haphazardly by <a href="https://github.com/cjx3711">cjx3711</a>{" "}
          |{" "}
          <a href="https://github.com/cjx3711/conventionpos">View on GitHub</a>
        </Typography>
      </Box>
    </Container>
  );
}
